let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("ffEVr"), load("hhss7"), load("1Y6tF")]).then(() => parcelRequire('b3HrA'));